import { EXPERIENCE_IDS } from '@/components/admin/experiences/contracts';
import { cn } from '@/lib/utils';
import { MessageSquareHeart } from 'lucide-react';

/**
 * La pastille « Retour » de la page de retour d'expérience (retour-experience.md
 * §7.1 ; maquette `timeline-retour.html`, choix 1 ; issue #176).
 *
 * Jaune (`jaune-tint` / `jaune-deep`, la couleur du badge « adieu » de la frise du
 * protocole) avec une icône de bulle : la page de retour se distingue sur la
 * scène, la vignette voisine et le rail comme la page protocole se distingue par
 * sa bordure, et ce jaune est le seul signe qu'une page AUTRE que le protocole
 * a un rôle dans le moteur. Deux emplacements, UN dessin :
 *
 * - `label` - à côté du nom de la page : sous la page du centre, dans le
 *   libellé d'une pastille du rail et dans la ligne de position du bandeau ;
 * - `frame` - posée dans le coin haut gauche d'une vignette voisine.
 *
 * Le texte « Retour » est le nom accessible : l'icône, elle, ne dit rien.
 */

export interface FeedbackBadgeProps {
  readonly placement?: 'label' | 'frame';
  readonly className?: string;
}

export function FeedbackBadge({ placement = 'label', className }: FeedbackBadgeProps) {
  return (
    <span
      data-testid={EXPERIENCE_IDS.feedbackBadge}
      className={cn(
        'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-pill bg-jaune-tint font-semibold text-jaune-deep ring-1 ring-jaune-deep/25 ring-inset',
        placement === 'frame'
          ? 'absolute top-1.5 left-1.5 z-10 py-0 pr-1.5 pl-1 text-[11px] leading-4'
          : 'py-0.5 pr-2.5 pl-2 text-xs leading-4',
        className,
      )}
    >
      <MessageSquareHeart aria-hidden="true" className="size-3" />
      Retour
    </span>
  );
}
